module.exports = __webpack_public_path__ + "static/add_lock_logo_long-d10b1b458556411ff207c095ce9b549a.png";